interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

function getPages(current: number, total: number): (number | string)[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | string)[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push('...');
  pages.push(total);
  return pages;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = getPages(current, total);

  return (
    <div className="flex items-center justify-center gap-1.5 flex-wrap mt-8">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className={`h-9 px-3 flex items-center gap-1 rounded-md text-sm border transition-colors ${
          current <= 1
            ? 'border-background-200 text-foreground-300 cursor-not-allowed'
            : 'border-background-200 text-foreground-600 hover:border-primary-400 hover:text-primary-500 cursor-pointer'
        }`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((page, index) =>
        typeof page === 'number' ? (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`w-9 h-9 flex items-center justify-center rounded-md text-sm font-medium cursor-pointer transition-colors ${
              page === current
                ? 'bg-primary-500 text-background-950'
                : 'text-foreground-600 hover:bg-background-100'
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={`ellipsis-${index}`} className="w-9 h-9 flex items-center justify-center text-foreground-400">
            ...
          </span>
        ),
      )}

      <button
        type="button"
        disabled={current >= total}
        onClick={() => onChange(current + 1)}
        className={`h-9 px-3 flex items-center gap-1 rounded-md text-sm border transition-colors ${
          current >= total
            ? 'border-background-200 text-foreground-300 cursor-not-allowed'
            : 'border-background-200 text-foreground-600 hover:border-primary-400 hover:text-primary-500 cursor-pointer'
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}